export default __webpack_public_path__ + "static/media/about.9bb45153.jpg";